export default __webpack_public_path__ + "static/media/A9202844_tn.24ab1595.jpg";